import { createBrowserRouter } from 'react-router-dom';
import routes from './routes';

export default createBrowserRouter(routes, {
  basename: process.env.PUBLIC_URL
});

